import actions from './actions.js';
import mutations from './mutations.js';

// state
const state = () => ({
  adminPickupAds: [],
  clinicPickupAds: [],
});

// getters
const getters = {
  adminPickupAds: (state) => state.adminPickupAds,
  clinicPickupAds: (state) => state.clinicPickupAds,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
